import React from 'react';
import { SearchX } from 'lucide-react';

/**
 * Shown when the panel shop in the URL can't be used: the ID is wrong, the
 * shop doesn't exist, it isn't accepting online requests, or a resume link has
 * expired. The customer can't fix any of those, so the page points them at the
 * only thing that will work — contacting the shop.
 */
const NotFoundPage = ({ error }) => (
  <div className="min-h-dvh flex items-center justify-center bg-background px-4 py-12">
    <div className="w-full max-w-md rounded-xl bg-card p-8 text-center shadow-sm">
      <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <SearchX className="h-7 w-7" />
      </span>

      <h1 className="text-xl font-semibold tracking-tight">We couldn't open that link</h1>

      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
        Please get in touch with the repairer directly to arrange your quote.
      </p>

      {error && typeof error === 'string' && (
        <p className="mt-5 rounded-lg bg-muted px-3 py-2.5 text-xs text-muted-foreground">{error}</p>
      )}

      <p className="mt-6 border-t border-black/5 pt-5 text-xs text-muted-foreground">
        If a repairer sent you this link, check with them that it is correct.
      </p>
    </div>
  </div>
);

export default NotFoundPage;
